<template>
  <nav
    class="navigation"
    aria-label="Основная навигация"
  >
    <ul class="navigation__list">
      <li
        v-for="(item, index) in getLinks"
        :key="`${item.code}-${index}`"
      >
        <router-link
          v-if="!item.subLinks"
          class="nav-item"
          :class="getActiveClasses(item)"
          :to="item.to"
          :aria-current="isActive(item) ? 'page' : null"
          @click.native="$emit('navigate')"
        >
          <span class="nav-item__icon">
            <component :is="item.icon" :size="19" aria-hidden="true" />
          </span>
          <span class="nav-item__title">{{ item.title }}</span>
        </router-link >

        <div
          v-else
          class="nav-item__sublinks"
        >
          <div
            class="sublink__header"
            :class="{ 'sublink__header--active': item.subLinks.some(isActive) }"
          >
            <span class="nav-item__icon">
              <component :is="item.icon" :size="19" aria-hidden="true" />
            </span>
            <span class="nav-item__title">{{ item.title }}</span>
          </div>

          <div class="nav-item__sublinks">
            <router-link
              v-for="sublink in item.subLinks"
              :key="`${sublink.code}-${index}`"
              class="nav-item__sublink"
              :class="getActiveClasses(sublink)"
              :to="sublink.to"
              :aria-current="isActive(sublink) ? 'page' : null"
              @click.native="$emit('navigate')"
            >
              <span class="nav-item__dot" aria-hidden="true" />
              <span class="nav-item__title">{{ sublink.title }}</span>
            </router-link >
          </div>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  House,
  MonitorSmartphone,
  PackageSearch,
  ChartBarStacked,
  ShoppingBasket,
  UsersRound,
  CalendarCheck,
  BadgeRussianRuble,
  Coins,
  Briefcase,
  Barcode,
  SquareLibrary,
  FolderClock,
  FileCog,
  UserCog
} from 'lucide-vue'

export default {
  name: 'NavigationSidebar',
  components: {
    House,
    MonitorSmartphone,
    PackageSearch,
    ChartBarStacked,
    ShoppingBasket,
    UsersRound,
    CalendarCheck,
    BadgeRussianRuble,
    Coins,
    Briefcase,
    Barcode,
    SquareLibrary,
    FolderClock,
    FileCog,
    UserCog
  },
  computed: {
    ...mapGetters('settings', ['getLinks'])
  },
  methods: {
    isActive ({ to }) {
      return this.$route.path === to
    },
    getActiveClasses (item) {
      return {
        'nav-item--active': this.isActive(item)
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
